/**
 * Created by zzy on 2019/8/8.
 */
export default {
  name: 'AppTreeSide',
  data () {
    return {
      content: null,
      timer: null
    }
  },
  props: {
    isOpen: {
      type: Boolean,
      default: true
    },
    // 自动调整边框高度
    autoResizeBorder: {
      type: Boolean,
      default: false
    },
    // 差
    diffSize: {
      type: Number,
      default: 30
    }
  },
  mounted() {
    // 返回首个内容对象
    if (this.content == null) {
      // 返回首个内容对象
      let contentArr = document.getElementsByClassName('layout-content')
      if (contentArr && contentArr.length) {
        for (let i = 0; i < contentArr.length; ++i) {
          if (!contentArr[i].hidden) { // 找到首个可见的元素
            this.content = contentArr[i]
            break
          }
        }
      }
    }

    // 重新设置边框线高度
    if (this.autoResizeBorder) {
      var _this = this
      this.timer = setInterval(() => {
        if (this.$refs.treeSideToggleLine.clientHeight > 0 &&
          _this.$refs.treeSideToggleLine.clientHeight !== _this.content.scrollHeight - _this.diffSize) { // 比较内容对象高度是否发生变化
          console.log('检测到内容高度发生变化')
          // 重新设置边框线高度
          _this.resizeToggleLine()
        } else {
          if (_this.content && _this.content.scrollHeight > _this.content.clientHeight) { // 父容器有滚动条
            if (_this.$refs.treeSideEmpty.clientHeight > 0) { // 空白区域高度不为0，降低其高度
              console.log('检测到内容高度发生变化')
              let diffHeight = _this.content.scrollHeight - _this.content.clientHeight
              if (_this.$refs.treeSideEmpty.clientHeight > diffHeight) {
                _this.$refs.treeSideEmpty.style.height = _this.$refs.treeSideEmpty.clientHeight - diffHeight + 'px'
              } else {
                _this.$refs.treeSideEmpty.style.height = '0'
              }
            }
          }
        }
      }, 100)
    }
  },
  beforeDestroy() {
    clearInterval(this.timer)
    this.timer = null
  },
  methods: {
    toggleTreeAside () {
      this.$emit('toggle', this.isOpen)
    },
    // 重新设置边框线高度
    resizeToggleLine() {
      this.$nextTick(() => {
        let contentHeight = this.content.scrollHeight - this.diffSize // 减去顶部30px padding
        if (this.$refs.treeSideToggleLine.clientHeight < contentHeight) { // 边框线高度小于内容高度
          let diffHeight = contentHeight - this.$refs.treeSideToggleLine.clientHeight
          this.$refs.treeSideEmpty.style.height = this.$refs.treeSideEmpty.clientHeight + diffHeight + 'px'
        } else if (this.$refs.treeSideToggleLine.clientHeight > contentHeight) { // 边框线高度大于内容高度
          let diffHeight2 = this.$refs.treeSideToggleLine.clientHeight - contentHeight
          if (this.$refs.treeSideEmpty.clientHeight > 0) { // 空白区域高度不为0，则降低其高度
            if (this.$refs.treeSideEmpty.clientHeight > diffHeight2) {
              this.$refs.treeSideEmpty.style.height = this.$refs.treeSideEmpty.clientHeight - diffHeight2 + 'px'
            } else {
              this.$refs.treeSideEmpty.style.height = '0'
            }
          } else { // 空白区域高度已为0，则减去线高度
            this.$refs.treeSideToggleLine.style.height = this.$refs.treeSideToggleLine.clientHeight - diffHeight2 + 'px'
          }
        }
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/appTreeSide/AppTreeSide.js